/* eslint-disable @typescript-eslint/no-var-requires */
export default typeof window === 'undefined'
  ? require('./ServerLogger').default
  : require('./BrowserLogger').default;
